import { render } from "./CardLoader.vue?vue&type=template&id=7b3c6661"
import script from "./CardLoader.vue?vue&type=script&lang=js"
export * from "./CardLoader.vue?vue&type=script&lang=js"

import "./CardLoader.vue?vue&type=style&index=0&id=7b3c6661&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__